import { GetServerSidePropsContext } from 'next'
import stringifyQuery from './stringifyQuery'
import setCookie from './setCookie'

const usingDeeplink = (
  context: GetServerSidePropsContext
): { accountId?: string; storeId?: string } => {
  const { req, res, query } = context

  const { poc, storeId } = stringifyQuery(query)

  if (poc) setCookie(res, 'REDUXPOC', poc)
  if (storeId) {
    setCookie(res, 'STOREKEY', '')
    setCookie(res, 'STOREID', storeId)
  }

  const { REDUXPOC = null, STOREID = null } = req.cookies

  return {
    storeId: storeId || STOREID,
    accountId: poc || REDUXPOC
  }
}

export default usingDeeplink
